import { merge } from 'ramda';
import * as types from './types';

import { GeneralSettingService } from '../../services/general-settings.service';

export const generalActions = {
  async [types.GENERAL_DATA.FETCH.ALL] ({commit}, payload) {
    const generalRes = await Promise.all([
      GeneralSettingService.findTerritoryDetails(),
      GeneralSettingService.findTerritories(),
    ]);

    const generalData = merge(...generalRes.map(e => e.data));
    console.log(generalData,"generalData");

    commit(types.GENERAL_DATA.SET.ALL, generalData);

  },
  async [types.UPDATE_EXCHANGE_RATES] ({commit, getters}, payload) {
    const updatedExch = await GeneralSettingService.updateExchangeRates();
    // console.log(updatedExch.data, getters.generalData.territories);
    commit(types.GENERAL_DATA.SET.ALL, {
      ...getters.generalData,
      ...updatedExch.data,
    });
  },
  async [types.Currencies.SET.ALL] ({commit, getters}, payload) {
    commit(types.GENERAL_DATA.SET.ALL, {
      ...getters.generalData,
      currencies: payload.currencies
    });
  },
  async [types.Territories.SET.ALL] ({commit, getters}, payload) {

    commit(types.GENERAL_DATA.SET.ALL, {
      ...getters.generalData,
      territories: payload.territories
    });
  },
  async [types.Territories.DELETE.SINGLE]({commit, getters}, payload) {
    const territory_id = payload;

    commit(types.GENERAL_DATA.SET.ALL, {
      ...getters.generalData,
      territories: getters.generalData.territories.filter(t => {
        if (t.territory_id === territory_id) {
          return false;
        } else {
          return true;
        }
      })
    });
    const deltedTerritory = await GeneralSettingService.removeTerritory({
      territory_id,
    });
  },
  async [types.Currencies.DELETE.SINGLE]({commit, getters}, payload) {
    const currency_id = payload;
    
    commit(types.GENERAL_DATA.SET.ALL, {
      ...getters.generalData,
      currencies: getters.generalData.currencies.filter(t => {
        if (t.currency_id === currency_id) {
          return false;
        } else {
          return true;
        }
      })
    });
    const deltedCurrency = await GeneralSettingService.removeCurrency({
      currency_id,
    });
  },
}